import { render, staticRenderFns } from "./AvataraUsuario.vue?vue&type=template&id=fbc9423c&scoped=true&"
import script from "./AvataraUsuario.vue?vue&type=script&lang=js&"
export * from "./AvataraUsuario.vue?vue&type=script&lang=js&"
import style0 from "./AvataraUsuario.vue?vue&type=style&index=0&id=fbc9423c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbc9423c",
  null
  
)

export default component.exports